import React, { useState } from "react";
import { 
    Menu, 
    Display, 
    Content, 
    ButtonMenu,
    TitleHeaderContainer,
    MenuToggle,
    SubMenu,
    ImageToggleMenuIcon,
    ToggleButtonMenuIcon,
    BoldToggleMenuIcon,
    SubMenuToggle,
    ButtonMenuToggle,
    SubMenuToggleContainerOut,
    IconContainer
} from '../styles';

import Logout from "../../components/Logout";
import Footer from "../../components/Footer";
import RegisterProtocol from "../../components/RegisterProtocol";
import ListProtocol from "../../components/ListProtocol";
import EditProtocol from "../../components/EditProtocol";
import ManagerSource from "../../components/ManagerSource";
import ManagerClassify from "../../components/ManagerClassify";
import ManagerUser from "../../components/ManagerUser";
import ManagerState from "../../components/ManagerState";
import ManagerMyProtocols from "../../components/ManagerMyProtocolos";
import ManagerMessagePredefined from "../../components/ManagerMessagePredefined";

import ImageIcon from "../../images/AplicLogoSIF.png";
import ToggleMenuIcon from "../../images/menu.png";

export default function Dashboard(){

    /*-------------------------------------------------------------------*/
    
        const [ registerProtocol, setRegisterProtocol ] = useState(true);
        const [ listProtocol, setListProtocol ] = useState(false);
        const [ editProtocol, setEditeProtocol ] = useState(false);
        const [ managerSource, setManagerSource ] = useState(false);
        const [ managerClassify, setManagerClassify ] = useState(false);
        const [ managerUser, setManagerUser ] = useState(false);
        const [ managerState, setManagerState ] = useState(false);
        const [ managerMyProtocols, setManagerMyProtocols ] = useState(false);
        const [ managerMessagePredefined, setManagerMessagePredefined ] = useState(false);
        const [ showToggle, setShowToggle ] = useState(false);

        const selected = (e) => { 
            if(e){ return { opacity: '.8' } }
            else{ return {} } 
        };

    /*-------------------------------------------------------------------*/
        function closeAll(){
            setRegisterProtocol(false);
            setListProtocol(false);
            setEditeProtocol(false);
            setManagerSource(false);
            setManagerClassify(false);
            setManagerUser(false);
            setManagerState(false);
            setManagerMyProtocols(false);
            setManagerMessagePredefined(false);
            setShowToggle(false);
        }

        function clickRegisterProtocol(){
            if(!registerProtocol){
                closeAll();
                setRegisterProtocol(true);
            }
        }

        function clickListProtocol(){
            if(!listProtocol){
                closeAll();
                setListProtocol(true);
            }
        }

        function clickEditProtocol(){
            if(!editProtocol){
                closeAll();
                setEditeProtocol(true);
            } 
        }

        function clickManagerSource(){
            if(!managerSource){
                closeAll();
                setManagerSource(true);
            }
        }

        function clickManagerClassify(){
            if(!managerClassify){
                closeAll();
                setManagerClassify(true);
            }
        }

        function clickManagerUser(){
            if(!managerUser){
                closeAll();
                setManagerUser(true);
            }
        }

        function clickManagerState(){
            if(!managerState){
                closeAll();
                setManagerState(true);
            }
        }

        function clickManagerMyProtocols(){
            if(!managerMyProtocols){
                closeAll();
                setManagerMyProtocols(true);
            } 
        }

        function clickManagerMessagePredefined(){
            if(!managerMessagePredefined){
                closeAll();
                setManagerMessagePredefined(true);
            }
        }
    /*-------------------------------------------------------------------*/

    return(
        <Display>
            <Menu>
                <IconContainer>
                    <img src={ ImageIcon } alt=""/>
                </IconContainer>
                <SubMenu>
                    <ButtonMenu style={ selected(registerProtocol) } onClick={ () => clickRegisterProtocol() } >Cadastrar Protocolo</ButtonMenu>
                    <ButtonMenu style={ selected(listProtocol) } onClick={ () => clickListProtocol() } >Listar Protocolos</ButtonMenu>
                    <ButtonMenu style={ selected(editProtocol) } onClick={ () => clickEditProtocol() } >Editar Protocolos</ButtonMenu>
                    <ButtonMenu style={ selected(managerSource) } onClick={ () => clickManagerSource() }>Destinos / Origens</ButtonMenu>
                    <ButtonMenu style={ selected(managerClassify) } onClick={ () => clickManagerClassify() }>Classificações</ButtonMenu>
                    <ButtonMenu style={ selected(managerUser) } onClick={ () => clickManagerUser() }>Usuários</ButtonMenu>
                    <ButtonMenu style={ selected(managerState) } onClick={ () => clickManagerState() }>Status</ButtonMenu>
                    <ButtonMenu style={ selected(managerMessagePredefined) } onClick={ () => clickManagerMessagePredefined() }>Mensagem Predefinida</ButtonMenu>
                    <ButtonMenu style={ selected(managerMyProtocols) } onClick={ () => clickManagerMyProtocols() }>Meus Protocolos</ButtonMenu>
                </SubMenu>
                <Logout/>
            </Menu>
            <MenuToggle>
                <ToggleButtonMenuIcon 
                    onClick={
                        () => setShowToggle(!showToggle) 
                    }
                >
                    { 
                        (showToggle)
                        ? 
                            <BoldToggleMenuIcon>X</BoldToggleMenuIcon>
                        : 
                            <ImageToggleMenuIcon src={ ToggleMenuIcon }/> 
                    }
                </ToggleButtonMenuIcon>
                {
                    (showToggle) &&
                    <>
                        <SubMenuToggle showToggle={ showToggle } >
                            <ButtonMenuToggle style={ selected(registerProtocol) } onClick={ () => clickRegisterProtocol() } >Cadastrar Protocolo</ButtonMenuToggle>
                            <ButtonMenuToggle style={ selected(listProtocol) } onClick={ () => clickListProtocol() } >Listar Protocolos</ButtonMenuToggle>
                            <ButtonMenuToggle style={ selected(editProtocol) } onClick={ () => clickEditProtocol() } >Editar Protocolos</ButtonMenuToggle>
                            <ButtonMenuToggle style={ selected(managerSource) } onClick={ () => clickManagerSource() }>Destinos / Origens</ButtonMenuToggle>
                            <ButtonMenuToggle style={ selected(managerClassify) } onClick={ () => clickManagerClassify() }>Classificações</ButtonMenuToggle>
                            <ButtonMenuToggle style={ selected(managerUser) } onClick={ () => clickManagerUser() }>Usuários</ButtonMenuToggle>
                            <ButtonMenuToggle style={ selected(managerState) } onClick={ () => clickManagerState() }>Status</ButtonMenuToggle>
                            <ButtonMenuToggle style={ selected(managerMessagePredefined) } onClick={ () => clickManagerMessagePredefined }>Mensagem Predefinida</ButtonMenuToggle>
                            <ButtonMenuToggle style={ selected(managerMyProtocols) } onClick={ () => clickManagerMyProtocols() }>Meus Protocolos</ButtonMenuToggle>
                        </SubMenuToggle>
                        <SubMenuToggleContainerOut>
                            <Logout/>
                        </SubMenuToggleContainerOut>
                    </>
                }
            </MenuToggle>
            <TitleHeaderContainer>
                <h1>Protocolo Sif</h1>
            </TitleHeaderContainer>
            <Content>
                { listProtocol && (<ListProtocol/>) }
                { registerProtocol && (<RegisterProtocol/>) }
                { editProtocol && (<EditProtocol/>) }
                { managerSource && (<ManagerSource/>) }
                { managerClassify && (<ManagerClassify/>) }
                { managerUser && (<ManagerUser/>) }
                { managerState && ( <ManagerState/> ) }
                { managerMessagePredefined && (<ManagerMessagePredefined/>)}
                { managerMyProtocols && ( <ManagerMyProtocols setManagerMyProtocols={ setManagerMyProtocols }/> ) }
            </Content>
            <Footer/>
        </Display>
    )
}